import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getAllActiveRes from './getAllActive.json';
import getClientStateRes from './getClientState.json';
import getClientCoffeeInvoiceDetailRes from './getCoffeeInvoiceDetail.json';
import findAllRes from './findAll.json';

const getAllActive = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}all-active-clients?removed=0`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllActiveRes>(url, config);
};

const getActives = (page?:number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}active-clients?removed=0&page=${page ?? 0}&size=${size ?? 20}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllActiveRes>(url, config);
};

const getById = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}find-client?id=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getAll = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}display-clients`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const findAll = (query: string, page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}search-client?q=${query}&removed=0&page=${page ?? 0}&size=${size ?? 1000}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof findAllRes>(url, config);
};

interface AddContact {
    'id':string,
    'contactPerson': {
        'firstname': string,
        'lastname': string,
        'position': string,
        'phoneNumber': string,
        'email': string,
        'role': number | string,
        'comPref': number | string
    }
}

const addContact = (data: AddContact) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-new-contact`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const deleteContact = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-contact`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  const data = {
    id,
  };
  return axios.post(url, data, config);
};

interface UpdateClientContactData {
    'id': string;
    'firstname': string;
    'lastname': string;
    'position': string;
    'phoneNumber': string;
    'email': string;
    'role': string;
    'comPref': string;
}

const updateContact = (data: UpdateClientContactData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-contact`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const getServiceInvoicesByClientName = (clientName: string, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-client-service-invoices?clientName=${clientName}&size=${size ?? 100}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getClientCoffeeInvoices = (clientId: string, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}coffee-invoices-by-client?clientId=${clientId}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getClientCoffeeInvoiceDetail = (invoiceId: string) => {
  console.log('Getting cstore invoice details...');
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}cstore-invoice-details?id=${invoiceId}`;
  console.log(url);
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getClientCoffeeInvoiceDetailRes>(url, config);
};

export interface UpdateClientData {
    'id': number;
    'name': string;
    'addressChanged': boolean;
    'address'?: {
        'streetAddress': string,
        'zipCode': string,
        'state': string,
        'city': string
    },
    'categoryId'?:number;
    'commision':number;
    'partnerId': number | null;
    'partnerCommission':number | null;
}

const update = (data: UpdateClientData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-client`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

interface PayInvoice {
    id: number;
    paidAmount: number;
}

const payServiceInvoice = (data: PayInvoice) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}pay-service-invoice`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const payCoffeeInvoice = (data: PayInvoice) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}pay-coffee-invoice`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const getAllStates = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}clients-state`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getClientStateRes>(url, config);
};

const getAllBusinessCategory = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-primary-categories`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

interface AddNewClientData {
    'name': string;
    'address': {
        'streetAddress': string;
        'zipCode': string;
        'state': string;
        'city': string;
    },
    'contactPerson': {
        'firstname': string;
        'lastname': string;
        'position': string;
        'phoneNumber': string;
        'email': string;
        'role': number;
        'comPref': number;
    },
    'partnerId': number | null | string;
    'partnerCommission': number;
    'commision': number;
    'categoryId': number;
}

const add = (data: AddNewClientData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-client`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const remove = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-client`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { id }, config);
};

const getByInitial = (initial?:string, page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}clients-by-initial?initial=${initial}&page=${page ?? 0}&size=${size ?? 20}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllActiveRes>(url, config);
};

const getPDFByInvoiceId = (id: number | null) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-cstore-invoice-pdf?id=${id}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

const uploadShopZioOrders = (data: FormData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}shopzio-upload-orders`;
  const config = {
    headers: {
      Authorization: `${ACCESS_TYPE} ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  return axios.post(url, data, config);
};

const sendCStoreInvoice = (data: any) => {
  const sendMethod = data.get('sendMethod');
  console.log(sendMethod);
  const token = sessionStorage.getItem('token');
  const url = sendMethod === 'email' ? `${VENDING_URL}send-cstore-invoice` : `${VENDING_URL}send-sms-cstore-invoice`;
  const config = {
    headers: {
      Authorization: `${ACCESS_TYPE} ${token}`,
    },
  };
  return axios.post(url, data, config);
};

const clients = {
  getAllActive,
  getById,
  getAll,
  findAll,
  addContact,
  deleteContact,
  updateContact,
  getServiceInvoicesByClientName,
  getClientCoffeeInvoices,
  getClientCoffeeInvoiceDetail,
  update,
  payServiceInvoice,
  payCoffeeInvoice,
  getAllStates,
  getAllBusinessCategory,
  add,
  remove,
  getByInitial,
  getPDFByInvoiceId,
  getActives,
  uploadShopZioOrders,
  sendCStoreInvoice,
};

export default clients;
